import React from 'react';

import classNames from '@utils/classnames';

export interface ISummaryBarProps {
  /** `DataField`s. Give one `className="w-full"` to put it on its own line. */
  children: React.ReactNode;
  className?: string;
}

/**
 * The key/value strip at the top of a detail page — one card, fields laid out in
 * a row with generous spacing, wrapping when the page gets narrow.
 */
export const SummaryBar: React.FC<ISummaryBarProps> = ({ children, className }) => {
  return (
    <div className={classNames('card flex flex-wrap items-center gap-x-7 gap-y-3.5 px-5 py-3.5', className)}>
      {children}
    </div>
  );
};
